import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { CreateSessionStepEnum, SessionGuideStepEnum, SessionTypeEnum } from '../../shared/models/session-guide.model';
import { LocalStorageService } from '../../shared/services/localStorage.service';

@Component({
  standalone: false,
  selector: 'app-smpp-session-guide',
  templateUrl: './smpp-session-guide.component.html',
  styleUrls: ['./smpp-session-guide.component.scss'],
})
export class SmppSessionGuideComponent implements OnInit {
  private localStorage = inject(LocalStorageService);

  selectedSessionType = signal<SessionTypeEnum>(SessionTypeEnum.WITH_SERVICE_TYPE);
  createSessionActiveStep = signal<CreateSessionStepEnum>(CreateSessionStepEnum.CREATE_SESSION);
  activeStep = signal<SessionGuideStepEnum>(SessionGuideStepEnum.PICK_SESSION_TYPE);

  isPickSessionTypeStepActive = computed(() => this.activeStep() === SessionGuideStepEnum.PICK_SESSION_TYPE);
  isSetupPlatformStepActive = computed(() => this.activeStep() === SessionGuideStepEnum.SETUP_PLATFORM);
  isPrevStepButtonDisabled = computed(() => this.activeStep() === SessionGuideStepEnum.PICK_SESSION_TYPE);
  isNextStepButtonDisabled = computed(() => this.activeStep() === SessionGuideStepEnum.CREATE_SESSION);

  ngOnInit(): void {
    const sessionGuideProgress = this.localStorage.get('session_guide');

    if (sessionGuideProgress) {
      this.activeStep.set(sessionGuideProgress.step);
      this.selectedSessionType.set(sessionGuideProgress.sessionType || SessionTypeEnum.WITH_SERVICE_TYPE);
      this.createSessionActiveStep.set(sessionGuideProgress.createSessionStep || CreateSessionStepEnum.CREATE_SESSION);
    }
  }

  onSessionTypeSelected(sessionType: SessionTypeEnum) {
    this.selectedSessionType.set(sessionType);
    this.updateSessionGuideProgress({
      step: SessionGuideStepEnum.PICK_SESSION_TYPE,
      sessionType,
    });
  }

  onSessionGuideStepClick(step: SessionGuideStepEnum) {
    this.activeStep.set(step);
    this.updateSessionGuideProgress({
      step,
    });
  }

  onCreateSessionStepClick(createSessionStep: CreateSessionStepEnum | null) {
    this.createSessionActiveStep.set(createSessionStep);
    this.updateSessionGuideProgress({
      step: SessionGuideStepEnum.CREATE_SESSION,
      createSessionStep,
    });
  }

  onNextStepClick() {
    const currentStep = this.activeStep();

    if (currentStep === SessionGuideStepEnum.PICK_SESSION_TYPE) {
      this.activeStep.set(SessionGuideStepEnum.SETUP_PLATFORM);
      this.updateSessionGuideProgress({
        step: SessionGuideStepEnum.SETUP_PLATFORM,
      });
    } else if (currentStep === SessionGuideStepEnum.SETUP_PLATFORM) {
      this.activeStep.set(SessionGuideStepEnum.CREATE_SESSION);
      this.updateSessionGuideProgress({
        step: SessionGuideStepEnum.CREATE_SESSION,
      });
    }
  }

  onPrevStepClick() {
    const currentStep = this.activeStep();

    if (currentStep === SessionGuideStepEnum.SETUP_PLATFORM) {
      this.activeStep.set(SessionGuideStepEnum.PICK_SESSION_TYPE);
      this.updateSessionGuideProgress({
        step: SessionGuideStepEnum.PICK_SESSION_TYPE,
      });
    } else if (currentStep === SessionGuideStepEnum.CREATE_SESSION) {
      this.activeStep.set(SessionGuideStepEnum.SETUP_PLATFORM);
      this.updateSessionGuideProgress({
        step: SessionGuideStepEnum.SETUP_PLATFORM,
      });
    }
  }

  updateSessionGuideProgress({
    step,
    sessionType,
    createSessionStep,
  }: {
    step: SessionGuideStepEnum;
    sessionType?: SessionTypeEnum;
    createSessionStep?: CreateSessionStepEnum;
  }) {
    this.localStorage.set('session_guide', {
      step,
      sessionType: sessionType || this.selectedSessionType(),
      createSessionStep: createSessionStep || this.createSessionActiveStep(),
    });
  }
}
